import { debounce } from 'vue-debounce';
import Api from '@/service/api';
import * as cardActivation from '@/helpers/card-activation';
import { MO_CARD_PIN_CODE_LENGTH } from '@/constants/constants';

import Input from '@/components/Form/Input/index.vue';
import CodeField from '@/components/Form/CodeField/index.vue';


export default {
  name: 'EmailVerification',

  components: {
    CodeField,
    Input,
  },

  methods: {
    async checkCode(code) {
      this.code = code;


      try {
        await Api.post({
          url: 'validate-card-code',
          data: { card_number: this.card, pin_code: this.code },
        });
      } catch (error) {
        this.isError = true;
        this.$refs.code.error();
        return;
      }

      this.isSuccess = true;
      this.$refs.code.success();
      cardActivation.saveMoCardData(this.card, this.code);
      this.toRegistration();
    },

    async checkCard(card) {
      this.card = card.replace(/^0+/, '');

      try {
        await Api.post({
          url: 'validate-card-number',
          data: { card_number: this.card },
        });
      } catch (error) {
        this.isError = true;
        this.$refs.card.error();
        this.errorCode = error.code;
        return;
      }

      this.isCardValid = true;
    },

    onChangeCard(value) {
      if (this.card !== value) {
        cardActivation.clearMoCardData();
        this.isError = false;
        this.isSuccess = false;
        this.isCardValid = false;
        this.code = null;
        if (this.$refs.code) {
          this.$refs.code.clear();
        }
      }
    },

    onChangeCode() {
      this.isError = false;
    },

    fieldsChanged() {
      this.validated = true;
      this.isError = false;
    },

    toRegistration() {
      debounce(() => {
        this.$router.push({
          name: 'EmailVerification',
          query: { isCardActivation: 'true' },
        });
      }, 2000)();
    },
  },

  created() {
    const localData = cardActivation.getMoCardData();

    if (localData) {
      this.card = localData.card_number;

      if (localData.pin_code) {
        this.code = localData.pin_code;
        this.isCardValid = true;
        this.isSuccess = true;
        this.toRegistration();
      }
    }
  },

  data() {
    return {
      card: null,
      code: null,
      email: null,
      errorCode: null,
      validated: this.validated || true,
      isError: false,
      isSuccess: false,
      isCardValid: false,
      codeLength: MO_CARD_PIN_CODE_LENGTH,
    };
  },
};
